$(document).ready(function() {
  setTimeout(function(){
    var splash_timer = parseInt($('#splash-timer').attr('data-splash-timer'))
    if (splash_timer.toLocaleString() == 'NaN') {
      splash_timer = 1000
    }

    $('.splash-swap').fadeOut(splash_timer);
    $('.wrapper-splash').remove();
    $('.wrapper-welcome').fadeIn(splash_timer);
    $('.wrapper-welcome').removeClass('d-none');
    $('body.welcomes-bg').addClass('page page-navigation');
  }, 2000);
})